const $ = jQuery.noConflict()

var self = module.exports = {
  init: function (target) {
    self.service.css(target)
  },

  service: {
    css: function (target) {
      var wrapper = $('#wrapper')
      var height = $(target).outerHeight()
      // console.log(height)
      $(wrapper).css('min-height', 'calc(100% - ' + height + 'px)')
    }
  }
}

function getUrlParameter (sParam) {
  var sPageURL = window.location.search.substring(1)
  var sURLVariables = sPageURL.split('&')
  var sParameterName = ''
  var i = 0

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
    }
  }
};


/*get ulr parameter floorplan and scroll ab active floorplan tab*/

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};


var floortab = getUrlParameter('vtour')

if (floortab) {
  $('#property-tabs > div').removeClass('active')
  $('#property-tabs > #property-tabs-vtour').addClass('active')
  $('.property-content__tabs li').removeClass('active')
  $('.property-content__tabs li[data-tab="#property-tabs-vtour"]').addClass('active')

  $('html, body').animate({
    scrollTop: $('#property-tabs').offset().top
  }, 1000)
}

setInterval(function () {
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off')
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off')
}, 1000)

jQuery('#property-valuation-address').on('keyup', () => {
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off')
})

$(".popular-search__title").click(function(){
  $(this).toggleClass('active');
  $(".popular-search__content").slideToggle();
})


var footer__top = $('.footer__top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 1000) {
    $('.footer__top').addClass('show');
  } else {
    $('.footer__top').removeClass('show');
  }
});

$('.footer__top').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});